import React from 'react';

type IconTextProps = {
  icon: React.ReactNode;
  label: React.ReactNode;
  data: React.ReactNode;
};

export const IconText: React.FC<IconTextProps> = ({ icon, label, data }) => {
  return (
    <div className="flex flex-row p-2 gap-2">
      <span className="text-gray-400 text-xs">{icon}</span>
      <div className="flex flex-col">
        <span className="text-xs leading-5 font-medium text-gray-500">{label}</span>
        <span className="text-sm leading-5 font-medium text-gray-700">{data}</span>
      </div>
    </div>
  );
};
